import { render, staticRenderFns } from "./RiepilogoEventi.vue?vue&type=template&id=07c55adc"
import script from "./RiepilogoEventi.vue?vue&type=script&lang=js"
export * from "./RiepilogoEventi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports